export enum Actions {
  SET = "interact-five9-set-interaction-id",
  RESET = "interact-five9-reset",
  SETSTORE = "store-five9-details",
  RESETSTORE = "store-five9-details-reset",
  SETCLICKTODIAL = "store-five9-clicktodial",
  RESETCLICKTODIAL = "store-five9-clicktodial-reset",
  SETNOTIFICATION = "store-five9-notification",
  RESETNOTIFICATION = "store-five9-notification-reset",
  SETCALLVARIABLES = "store-five9-call-variables",
  SETLOGOUTCODES = "store-five9-logout-codes",
  SETUSERSTATE = "store-five9-user-state",
  RESETUSERSTATE = "store-five9-user-state-reset",
}
